import { pick, extend, isString } from 'underscore';
import {
  modelToViewModelForDayTimeTargets,
  modelToViewModelForLocationTargets,
  bulkModelToViewModelForDayTimeTargets,
  bulkModelToViewModelForLocationTargets,
} from '@bingads-webui-campaign-react/perf-max-step-wizard';

import { CampaignNegativeReferenceId } from '../shared/constants';

const whitelistedSchemaPropertyKeysForModel = [
  'Notes', 'Budget', 'Id', 'Name', 'TimeZone', 'BidStrategyName',
  'DeliveryStatus', 'DeliveryStatusDetails', 'CampaignType', 'CampaignSubType',
  'HasAuctionInsight', 'IsBidLandscapeAvailable', 'TrackingUrlTemplate',
  'FinalUrlSuffix', 'UrlCustomParameters', 'BiddingScheme', 'NativeBidAdjustment',
  'CampaignSettings', 'DisplayBiddingStrategyType',
  'DisplayBiddingStrategyMaxCpc', 'DisplayBiddingStrategyTargetCpa', 'Languages',
  'ExperimentId', 'Name', 'TargetSetting',
  'AdScheduleUseSearcherTimeZone', 'AvailableInsightTypeIds',
  'MultiMediaAdBidAdjustment',
  // 'CampaignCashback', 'KeywordVariantMatchEnabled',
];

export const viewModelToBulkModelForCampaign = (campaignViewModel) => {
  const model = pick(campaignViewModel.data, whitelistedSchemaPropertyKeysForModel);

  if (!campaignViewModel.data.Id) {
    model.Id = CampaignNegativeReferenceId;
  }
  return model;
};

export const bulkModelToViewModelForCampaign = ({
  campaignModel,
  bundleCountries,
}) => {
  let data = pick(campaignModel, whitelistedSchemaPropertyKeysForModel);
  if (data.Id && isString(data.Id)) {
    // eslint-disable-next-line no-param-reassign
    data.Id = parseInt(data.Id, 10);
  }
  data = extend(data, bulkModelToViewModelForDayTimeTargets({
    criterions: campaignModel.CampaignCriterions,
  }));
  data = extend(data, bulkModelToViewModelForLocationTargets({
    locationTargetsModel: campaignModel.CampaignCriterions,
    bundleCountries,
  }));

  const campaignViewModel = {
    data,
    isValid: true,
    isDirty: false,
  };
  return campaignViewModel;
};

export const modelToViewModelForCampaign = ({
  campaignModel,
  dayTimeCriterionsModel,
  locationCriterionsModel,
  bundleCountries,
}) => {
  let data = pick(campaignModel, whitelistedSchemaPropertyKeysForModel);
  if (dayTimeCriterionsModel) {
    data = extend(data, modelToViewModelForDayTimeTargets({
      model: dayTimeCriterionsModel,
    }));
  }

  if (locationCriterionsModel) {
    data = extend(data, modelToViewModelForLocationTargets({
      model: locationCriterionsModel,
      bundleCountries,
      campaignId: campaignModel.Id,
    }));
  }

  data = extend(data, {
    ManualCPI: campaignModel.BiddingScheme.ManualCPI || 5,
  });

  const campaignViewModel = {
    data,
    isValid: true,
    isDirty: false,
  };
  return campaignViewModel;
};
